import { Directive, HostBinding, Input } from '@angular/core';


export type MuiSpacingValue = 0 | 1 | 2 | 3 | 4 | 5 | '0' | '1' | '2' | '3' | '4' | '5' | 'auto';

@Directive({
  // Disable the directive-selector rule because we want to have the directive name as short as possible for easier usage.
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[p],[ps],[pe],[pt],[pb],[px],[py],[m],[ms],[me],[mt],[mb],[mx],[my]'
})
export class MuiSpacingDirective {
  @Input() p?: MuiSpacingValue;
  @Input() ps?: MuiSpacingValue;
  @Input() pe?: MuiSpacingValue;
  @Input() pt?: MuiSpacingValue;
  @Input() pb?: MuiSpacingValue;
  @Input() px?: MuiSpacingValue;
  @Input() py?: MuiSpacingValue;
  @Input() m?: MuiSpacingValue;
  @Input() ms?: MuiSpacingValue;
  @Input() me?: MuiSpacingValue;
  @Input() mt?: MuiSpacingValue;
  @Input() mb?: MuiSpacingValue;
  @Input() mx?: MuiSpacingValue;
  @Input() my?: MuiSpacingValue;

  @HostBinding('class')
  protected get className(): string {
    const classes = this.getSpacingClasses();

    if (classes.length > 0) {
      return classes.join(' ');
    }

    return this.getDefaultClasses();
  }

  private getSpacingClasses(): string[] {
    return [
      this.p ? `p-${this.p}` : null,
      this.ps ? `ps-${this.ps}` : null,
      this.pe ? `pe-${this.pe}` : null,
      this.pt ? `pt-${this.pt}` : null,
      this.pb ? `pb-${this.pb}` : null,
      this.px ? `px-${this.px}` : null,
      this.py ? `py-${this.py}` : null,
      this.m ? `m-${this.m}` : null,
      this.ms ? `ms-${this.ms}` : null,
      this.me ? `me-${this.me}` : null,
      this.mt ? `mt-${this.mt}` : null,
      this.mb ? `mb-${this.mb}` : null,
      this.mx ? `mx-${this.mx}` : null,
      this.my ? `my-${this.my}` : null
    ].filter((v): v is string => v !== null);
  }

  private getDefaultClasses(): string {
    const keys: Array<keyof this> = Object.keys(this) as Array<keyof this>;
    const inputPropKeys = keys.filter(key => key.toString().startsWith('p') || key.toString().startsWith('m'));
    const usedSelectors = inputPropKeys.filter(key => this.hasSelector(key));
    return usedSelectors.map(s => s.toString() + '-3').join(' ');
  }

  private hasSelector(selector: keyof this): boolean {
    return typeof this[selector] !== 'undefined';
  }
}
